module.exports = __webpack_public_path__ + "img/sink.2819f578.png";